var Industry = "Industry";
var Aerospace = "Aerospace";
var Agriculture = "Agriculture";
var Automotive = "Automotive";
var Education = "Education";
var Gaming = "Gaming";
var Government = "Government";
var Healthcare = "Healthcare";
var Hospitality = "Hospitality";
var Manufacturing = "Manufacturing";
var Mining = "Mining";
var Other = "Other";
var Retail = "Retail";
var Telecommunications = "Telecommunications";
var Travel = "Travel";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Computers & electronics",
	"Consumer goods": "Consumer goods",
	Education: Education,
	"Financial services": "Financial services",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Life sciences",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Marketing & advertising",
	"Media & entertainment": "Media & entertainment",
	Mining: Mining,
	"Non-profit organization": "Non-profit organization",
	"Oil & gas": "Oil & gas",
	Other: Other,
	"Power & utilities": "Power & utilities",
	"Professional services": "Professional services",
	"Real estate & construction": "Real estate & construction",
	Retail: Retail,
	"Software & internet": "Software & internet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Transportation & logistics",
	Travel: Travel,
	"Wholesale & distribution": "Wholesale & distribution"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
